import React from "react";
var __jsx = React.createElement;
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
var CreditCardInfoShimmer = function CreditCardInfoShimmer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "gray" : _ref$color;
  return /*#__PURE__*/React.createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24.5,
    divWidth: 192,
    className: "mb-2",
    appearance: {
      color: color
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 56,
    divWidth: "100%",
    className: "mb-8",
    appearance: {
      color: color
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24.5,
    divWidth: 192,
    className: "mb-2",
    appearance: {
      color: color
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 56,
    divWidth: "100%",
    className: "mb-0.5",
    appearance: {
      color: color
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 mb-6"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 56,
    divWidth: "50%",
    appearance: {
      color: color
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 56,
    divWidth: "50%",
    appearance: {
      color: color
    }
  }))), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 56,
    divWidth: "100%",
    appearance: {
      color: "green"
    }
  }));
};
export default CreditCardInfoShimmer;